import VendorForm from './VendorForm';

export {
  VendorForm
}



// WEBPACK FOOTER //
// ./src/components/admin/Vendors/index.js